<template>
  <div >
    <p class="headerstyle">แก้ไขหลักสูตร</p>
    <div class="fromstyle">
      <form @submit.prevent="checkForm">        
        <br />
        <!-- <label class="text-black headerstyle">Banner คอร์สเรียน</label>
        <br />
        <vs-radio class="radioitem" vs-name="" vs-value="link" v-model="publish"
          >เผยเเพร่ Banner คอร์สเรียนแบบ LIVE สด
        </vs-radio>
        <br />
        <vs-input
          class="w-full mt-3"
          placeholder="URL Embed link"
          v-if="publish === 'link'"
          v-model="Url"
        />
        <br />
        <vs-radio class="radioitem" vs-name="" vs-value="pic" v-model="publish"
          >เผยเเพร่ Banner คอร์สเรียนแบบรูปภาพ
        </vs-radio>
        
        <button
          v-if="publish === 'pic'"
          class="mt-5 uploadfield"
          @dragover.prevent
          @drop.prevent
          @click="onPickBannerImg"
        >
          <div @drop="dragBannerImg" class="flex items-center h-full">
            <img
              v-if="bannerImg"
              class="h-full object-contain"
              :src="bannerImg"
            />
            <img
              v-show="!bannerImg"
              src="@/assets/images/elements/uploadbanner.svg"
            />
          </div>
        </button>
        <input
          type="file"
          style="display: none"
          ref="BannerImgInput"
          @change="uploadBannerImg"
        />

        <img class="my-10 w-full" src="@/assets/images/elements/Line 30.svg" /> -->

        <label class="text-black headerstyle">เนื้อหาหลักสูตร</label>
        <p id='fadeIn' v-if="errors.length || errors_Curriculum.length || errors_Curriculum_code.length" class="error-style">
        <b>กรุณากรอกข้อมูลให้ถูกต้อง :</b>
          <ul>
            <li  v-for="error in errors" :key="error">{{ error }}</li>
            <li  v-for="error in errors_Curriculum" :key="error">{{ error }}</li>
            <li  v-for="error in errors_Curriculum_code" :key="error">{{ error }}</li>
          </ul>
        </p>
        <button
          class="mt-5 uploadfield"
          @dragover.prevent
          @drop.prevent
          @click="onPickCourseImg"
          type="button"
        >
          <div @drop="dragCourseImg" class="flex items-center justify-center  h-full">
            <img
              v-if="courseImg"
              class="h-full w-full object-contain"
              :src="courseImg.url"
            />
            <img
              v-show="!courseImg"
              src="@/assets/images/elements/uploadbanner.svg"
            />
          </div>
        </button>
        <input
          type="file"
          accept="image/*"
          style="display: none"
          ref="CourseImgInput"
          @change="uploadCourseImg"
        />

        <br />
        <div class="flex justify-center">
          <div class="w-3/5">

            <vs-input
              class="w-3/5 sm:w-2/5 mb-5"
              placeholder="รหัสหลักสูตร"
              v-model="curriculum_code"
              v-debounce:500ms="CheckCurriculum_code"
              required
            />
            <vs-input
              class="w-full mb-5"
              type="text"
              id="header"
              placeholder="ชื่อหลักสูตร"
              v-model="curriculum"
              v-debounce:500ms="CheckCurriculum_name"
              required
            />
           
            <vs-textarea
              label="รายละเอียดหลักสูตร"
              height="200px"
              v-model="description"
              required
            />
            
            <select class="mb-5 custom-select" v-model="usertype" id="usertype" name="usertype" required>
            <option :value="null" disabled selected>หลักสูตร</option>
            <option >หลักสูตรหลัก</option>
            <option >หลักสูตรเฉพาะกลุ่ม</option>
            </select>
            <p class="m-0">โปรดระบุประเภทหลักสูตร</p>
            <multiselect
              class="cus-select"
              v-model="curriculumtype"
              tag-placeholder="ประเภทหลักสูตร"
              placeholder="ประเภทหลักสูตร"
              label="name"
              track-by="code"
              :options="options"
              :multiple="true"
              :taggable="true"
              @tag="addTag"
              :allow-empty="false"
            ></multiselect>

            <div class="flex justify-center">
              <button class="share-btn" type="submit" value="Submit" :disabled=isDisable>
                แก้ไขหลักสูตร
              </button>
            </div>
            
          </div>
        </div>
        <p class="footer-text">
              หลักสูตรเมื่อถูกเพิ่มแล้ว จะอยู่ในสถานะ “ยังไม่เผยแพร่”<br />
              โดยสามารถปรับเป็น “เผยแพร” ได้ในภายหลัง
            </p>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "../../../util/backend";
import normAxios from "axios";
import Multiselect from "vue-multiselect";
import baseUrl from '../../../util/baseUrl';

export default {
  methods: {
    async checkForm(e) {
      console.log( this.curriculumtype[0]);
      if (this.curriculumtype[0]&&this.courseImg) {
        this.$vs.loading();
        let array_id = []
        for await ( let item of this.curriculumtype ){
          array_id.push(item.code)
        }

        let config = {
          method: "put",
          url: `${baseUrl.baseurl()}/editCurriculum`,
          data: {
            curriculum_id : this.data.curriculum_id,
            curriculum: this.curriculum.trimLeft(),
            curriculum_code: this.curriculum_code.trimLeft(),
            desc: this.description,
            img_url: this.courseImg.url,
            category_curriculum_id : array_id
          },
         
        };
        await axios.api(config).then((res) => {
          console.log(res.data.status);
          this.$vs.loading.close()
          this.$vs.notify({title:'แก้ไขหลักสูตร',text:'สำเร็จ',color:'success',icon:'check_box',position:'top-right'})
          this.$router.push({ path: "/curriculum" });
        
        })
        .catch((error)=>{
          //console.log("error",error.response.data.error);
          this.$vs.notify({title:'Error message',text:`${error.response.data.error?error.response.data.error:error}` ,color:'danger',icon:'error',position:'top-right'})
          this.$vs.loading.close()
        })
      }

      this.errors = [];

      if (!this.curriculumtype[0]) {
        this.errors.push("กรุณาเลือกรูปแบบหลักสูตรอย่างน้อย 1 หลักสูตร")
        this.$vs.notify({
          title: "กรุณากรอกข้อมูลให้ถูกต้อง",
          text: "กรุณาอัพโหลดภาพปก",
          color: "danger",
          icon: "error",
          position: "top-right",
        });
      }
      if (!this.courseImg) {
         this.errors.push("กรุณาอัพโหลดภาพปก")
         this.$vs.notify({
          title: "กรุณากรอกข้อมูลให้ถูกต้อง",
          text: "กรุณาอัพโหลดภาพปก",
          color: "danger",
          icon: "error",
          position: "top-right",
        });
      }
    },

    //////Course Image///////
    onPickCourseImg() {
      this.$refs.CourseImgInput.click();
    },
    async dragCourseImg(e) {
      console.log("file drag", e.dataTransfer.files[0]);
      this.courseImg = await this.uploadFile(e.dataTransfer.files[0]);
    },
    async uploadCourseImg(e) {
      console.log("file click", e.target.files[0]);
      this.courseImg = await this.uploadFile(e.target.files[0]);
    },

    //////Banner Image///////
    onPickBannerImg() {
      this.$refs.BannerImgInput.click();
    },
    async dragBannerImg(e) {
      console.log("file drag", e.dataTransfer.files[0]);
      this.bannerImg = await this.uploadFile(e.dataTransfer.files[0]);
    },
    async uploadBannerImg(e) {
      console.log("file click", e.target.files[0]);
      this.bannerImg = await this.uploadFile(e.target.files[0]);
    },

    async uploadFile(file) {
      let fd = new FormData();
      fd.append("file", file);
      fd.append("folder_id", 1);
      try {
        let res = await normAxios.post(
          "https://api.fastation.co.th/file/api/file/create",
          fd
        );
        console.log(res.data);
        if (res.status == 200) {
          return res.data.data.uploadFileAtLevel;
        } else {
          alert(res.data.message);
        }
      } catch (error) {
        alert(error.response.data.message.toString());
      }
    },
    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.options.push(tag);
      this.curriculum.push(tag);
    },

    Syncdata(){
      this.curriculum = this.data.curriculum
      this.description = this.data.description
      this.courseImg = {url:this.data.cover_img}
      this.Url = this.data.banner_live
      this.bannerImg = this.data.public_banner
      this.curriculum_code = this.data.curriculum_code
      this.usertype = this.data.category_curriculum_lists[0].category_curriculum.type
      for( let item of this.data.category_curriculum_lists){
        this.curriculumtype.push({
          code: item.category_curriculum.category_curriculum_id,
          name: item.category_curriculum.title
        })
      }

    },
    CheckCurriculum_name() {
     if(this.curriculum){ 
       this.errors_Curriculum = []
      axios.api.post(`${baseUrl.baseurl()}/checkCurriculumUpdateExist`,
      {
        curriculum_id : this.data.curriculum_id,
        curriculum : this.curriculum.trimLeft()
      })
      .then((res)=>{
        this.isDisable = false
      })
      .catch((err)=>{
        this.errors_Curriculum.push(err.response.data.error)
        this.isDisable = true
      })}

    },
    CheckCurriculum_code() {
     if(this.curriculum_code) {
       this.errors_Curriculum_code = []
      axios.api.post(`${baseUrl.baseurl()}/checkCurriculumUpdateExist`,
      {
        curriculum_id : this.data.curriculum_id,
        curriculum_code : this.curriculum_code.trimLeft()
      })
      .then((res)=>{
        this.isDisable = false
      })
     .catch((err)=>{
        this.errors_Curriculum_code.push(err.response.data.error)
        this.isDisable = true
    })}
  },
  },

  async mounted() {
    this.$store.dispatch("general/get_curriculumtype_choice",this.data.category_curriculum_lists[0].category_curriculum.type)
    this.Syncdata()
  },
  data() {
    return {
      description: null,
      publish: null,
      Url: null,
      bannerImg: null,
      courseImg: null,
      curriculum: null,
      curriculum_code: null,
      curriculumtype: [],
      errors:[],
      errors_Curriculum:[],
      errors_Curriculum_code:[],
      isDisable: false,
      usertype: null
    };
  },
  computed: {
    ...mapGetters({
      options : "general/choice",
      data: "general/editPage",
    }),

    PublishType() {
      this.Url ? 
      this.publish = 'link':
      this.bannerImg ?
      this.publish = 'img': 
      this.publish = null
    }
  },

  components: {
    Multiselect,
  },

  watch: {
    usertype(newValue, oldValue) {
      if(oldValue != null){
         this.curriculumtype = []
         this.$store.dispatch("general/get_curriculumtype_choice",newValue)
      }
    }
  },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
.uploadbanner {
  height: 100px;
}
.fromstyle {
  padding: 0;
}

.share-btn {
  background-color: #0430ad;
  padding: 10px 20px 10px 20px;
  border-radius: 10px;
  border-style: none;
  color: #ffff;

  &:hover {
    transition-delay: 100ms;
    background-color: #072c49;
  }
  &:active {
    background-color: #072c49;
  }
  &:disabled {
    background-color: gray;
    color: black;
  }
}

.radiobanner {
  display: flex;
  justify-content: flex-start;
}
.radioitem {
  margin-right: 10px;
}
.fixtimepicker {
  z-index: 99;
}
.bannerimage {
  height: 250px;
  max-width: 100%;
}

.headerstyle {
  color: #1a3683;
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 600;
  text-align: center;
}


.upload-btn {
  border-radius: 10px;
  border-style: none;
  height: 42.5px;
}
.upload-btn-img {
  height: 42.5px;
}

.cus-select {
 font-size: .9rem !important;
 margin-bottom: 2rem;
 
}

.cus-select .multiselect__tags {
  font-size: .9rem !important;
  border: 2px solid #0430AD;
  color:rgba(4, 48, 173, 0.5);
}

.cus-select .multiselect__input:focus {
  font-size: .9rem !important;
}

</style>